/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getDecisionByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getDecisionByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetDecisionById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getDecisionByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getDecisionByIdPayloadRegExpTwo)]).optional()
});

export type GetDecisionById = zod.input<typeof GetDecisionById>;
export type GetDecisionByIdOutput = zod.output<typeof GetDecisionById>;
